import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import theme from '../../themes/theme';

interface IProps {
  title?: string;
}

const SectionHeader: React.FC<IProps> = ({ title }) => {
  return (
    <Grid
      style={{
        width: '100%',
        backgroundColor: theme.palette.primary.main,
        textAlign: 'center',
        color: '#fff',
      }}
    >
      <Typography variant='h6'>
        {title !== undefined && title !== '' ? title : null}
      </Typography>
    </Grid>
  );
};

export default SectionHeader;
